import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

const setTextTruncate = (textTruncate: boolean): SerializedStyles => {
    if (textTruncate) {
        return css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        `;
    }
    return css`
        overflow-wrap: anywhere;
        word-break: break-word;
    `;
};

interface RunnerNameAndPlaceType {
    textTruncate: boolean;
}

export const RunnerNameAndPlace = withConfig(theme => styled('div', { label: 'RunnerNameAndPlace' })<RunnerNameAndPlaceType>`
    ${({ textTruncate }): SerializedStyles => setTextTruncate(textTruncate)};
    color: ${theme.star.raceSummary.txtColor};
    font-size: ${theme.star.raceSummary.typography.fontSizePrimary};
    line-height: ${theme.star.raceSummary.typography.lineHeightPrimary};
    font-weight: ${theme.star.raceSummary.typography.fontWeightPrimary};
`);

interface RunnerDetailsWrapperType {
    textTruncate: boolean;
}

export const RunnerDetailsWrapper = withConfig(theme => styled('div', { label: 'RunnerDetailsWrapper' }) <RunnerDetailsWrapperType>`
    ${({ textTruncate }): SerializedStyles => setTextTruncate(textTruncate)};
    color: ${theme.star.raceSummary.txtColorSecondary};
    font-size: ${theme.star.raceSummary.typography.fontSizeSecondary};
    line-height: ${theme.star.raceSummary.typography.lineHeightSecondary};
    width: 100%;
`);

export const RunnerDetails = styled('i', { label: 'RunnerDetails' })`
    font-style: normal;
    position: relative;
    &::after {
        content: '•';
        margin: 0 4px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;
